<script>
  import Image from "../Image.svelte";
  export let block;

  const layout = block.fields.reduce((prev, cur, index) => {
    switch (index % 6) {
      case 0:
      case 4:
        prev.push([]);
      // fallthrough
      case 1:
      case 5:
        prev[prev.length - 1].push(cur);
        break;
      case 2:
      // fallthrough
      case 3:
        prev.push(cur);
        break;
    }
    return prev;
  }, []);

  const getImage = (image) => {
    const portrait = Object.fromEntries(
      Object.entries(image)
        .filter(([key]) => key.indexOf("portrait-") === 0)
        .map(([key, value]) => [key.replace("portrait-", ""), value]),
    );
    return {
      ...portrait,
      ...portrait.main,
    };
  };
</script>

<div class="flex flex-wrap">
  {#each layout as l}
    {#if l.gallery_image}
      <div class="w-full sm:w-1/2">
        <Image image={getImage(l.gallery_image)} />
      </div>
    {:else}
      <div class="w-full sm:w-1/2 flex flex-col">
        {#each l as { gallery_image }}
          <Image image={gallery_image} class="h-full object-cover" intersectionClass="h-1/2" />
        {/each}
      </div>
    {/if}
  {/each}
</div>
